// Вікно «Потрібен сайт?» (заявка для HelixWave): відкривається з підпису у футері.
const modal    = document.getElementById('dev-support');
const trigger  = document.getElementById('dev-support-trigger');
const closeBtn = document.getElementById('dev-support-close');

if (modal && trigger) {
	// Turnstile для форми вантажиться лише при першому відкритті (див. helixwave_lazy_turnstile_tag).
	const loadTurnstile = () => {
		const lazy = document.querySelector('script[data-lazy-src]#cfturnstile-js');
		if (!lazy || lazy.dataset.loaded) return;
		lazy.dataset.loaded = '1';
		const s = document.createElement('script');
		s.src = lazy.dataset.lazySrc;
		s.async = true;
		document.head.appendChild(s);
	};

	const open = () => {
		loadTurnstile();
		modal.classList.add('is-open');
		modal.setAttribute('aria-hidden', 'false');
		modal.inert = false;
		document.body.style.overflow = 'hidden';
		const field = modal.querySelector('input:not([type="hidden"]), textarea');
		if (field) field.focus();
	};

	const close = () => {
		modal.classList.remove('is-open');
		modal.setAttribute('aria-hidden', 'true');
		modal.inert = true; // закрите вікно — поза фокусом і деревом доступності
		document.body.style.overflow = '';
		trigger.focus();
	};

	trigger.addEventListener('click', (e) => {
		e.preventDefault();
		open();
	});

	if (closeBtn) closeBtn.addEventListener('click', close);

	modal.addEventListener('click', (e) => {
		if (e.target === modal) close();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
	});
}
